import { TiendaAsociada, TiendaAsociadaForm, TiendaAsociadaUpsert } from '@models/.';

export function transformToData(associatedStore: TiendaAsociada | null): TiendaAsociada | null {
  if (!associatedStore) return null;
  
  return {
    ...associatedStore,
  };
}

export function transformToForm(associatedStore?: TiendaAsociada): TiendaAsociadaForm | undefined {
  if (!associatedStore) return;
  
  const {
    id,
    nombre
  } = associatedStore;
  
  return {
    id,
    name: nombre,
  };
}

export function transformArrayForm(associatedStores: TiendaAsociada[] | null | undefined): TiendaAsociadaForm[] {
  return (associatedStores ?? []).map((associatedStoreForm) => (transformToForm(associatedStoreForm)) as TiendaAsociadaForm) ?? [];
}

export function transformToUpsert(associatedStoreForm: TiendaAsociadaForm): TiendaAsociadaUpsert | undefined {
  if (!associatedStoreForm) return;
  
  const {
    id,
    name,
  } = associatedStoreForm
  
  return {
    id,
    nombre: name,
  };
}